import React, { useRef } from 'react';
import { Button } from 'reactstrap';
import { FaUpload } from 'react-icons/fa';

const FileUploadButton = ({ onFilesSelected }) => {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (onFilesSelected) {
            onFilesSelected(files);
        }
    };

    return (
        <>
            <Button color="default" size="md" outline type="button" onClick={handleButtonClick}>
                <FaUpload style={{marginRight: '8px'}}/>
                Upload Files
            </Button>
            <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{display: 'none'}}
            />
        </>
    );
};

export default FileUploadButton;
